import { getCallable } from "../_sdk/client";
import { apiName, endpoints } from "./endpoints";
import {
    DeleteSharedThemeRequest, DeleteSharedThemeResponse,
    GetSharedThemeRequest, GetSharedThemeResponse,
    UpdateSharedThemeRequest, UpdateSharedThemeResponse,
    CreateSharedThemeRequest, CreateSharedThemeResponse,
} from "./types";

const getSharedTheme = getCallable<GetSharedThemeRequest, GetSharedThemeResponse>(apiName, "getSharedTheme", {
    ...endpoints.getSharedTheme,
    composer: request => {
        return {
            url: `/shared-themes/${encodeURIComponent(request.id)}`,
            options: {
                method: "GET"
            }
        };
    }
});

const updateSharedTheme = getCallable<UpdateSharedThemeRequest, UpdateSharedThemeResponse>(apiName, "updateSharedTheme", {
    ...endpoints.updateSharedTheme,
    composer: request => {
        return {
            url: `/shared-themes/${encodeURIComponent(request.id)}`,
            options: {
                method: "PUT",
                body: JSON.stringify(request)
            }
        };
    }
});

const deleteSharedTheme = getCallable<DeleteSharedThemeRequest, DeleteSharedThemeResponse>(apiName, "deleteSharedTheme", {
    ...endpoints.deleteSharedTheme,
    composer: request => {
        return {
            url: `/shared-themes/${encodeURIComponent(request.id)}`,
            options: {
                method: "DELETE"
            }
        };
    }
});

const createSharedTheme = getCallable<CreateSharedThemeRequest, CreateSharedThemeResponse>(apiName, "createSharedTheme", {
    ...endpoints.createSharedTheme,
    composer: request => {
        return {
            url: `/shared-themes/${encodeURIComponent(request.id)}`,
            options: {
                method: "POST",
                body: JSON.stringify(request)
            }
        };
    }
});

export const callables = {
    getSharedTheme,
    updateSharedTheme,
    deleteSharedTheme,
    createSharedTheme,
};
